<template>
  <v-app>
    <v-toolbar app elevation="0" class="c_toolbar" color="rgb(238, 238, 238)">
      <v-app-bar-nav-icon @click="ev_menu"></v-app-bar-nav-icon>
      <v-toolbar-title align="start" justify="center">
        <v-img src="@/assets/tonaescola.png" contain height="32" position="0"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>     
      <v-avatar size="32">
        <v-img src="@/assets/menino.jpg"></v-img>
      </v-avatar>
      <v-btn icon style="margin-right:5px">
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>

    </v-toolbar>

    <v-layout fill-height>
      <v-row>
        <v-navigation-drawer color="rgb(238, 238, 238)" v-if="mostrar_menu">
          <v-list nav dense>
            <v-list-item-group v-model="selectedItem" color="primary">
              <v-list-item v-for="(item, i) in items" :key="i" @click="clickItemMenu(i)">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>

        <v-main>
          <v-layout fill-height>
            <router-view :class="mostrar_menu == true ? 'mainView_menu' : 'mainView'"></router-view>
          </v-layout>
        </v-main>

      </v-row>
    </v-layout>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    selectedItem: 0,
    items: [
      { text: 'Painel de controle', icon: 'mdi-folder' },
      { text: 'Colaboradores', icon: 'mdi-account-multiple' },
      { text: 'Turmas', icon: 'mdi-star' },
      { text: 'Alunos', icon: 'mdi-history' },
      { text: 'Registro diário', icon: 'mdi-check-circle' },
      { text: 'Conversas', icon: 'mdi-upload' },
      { text: 'Parametrização', icon: 'mdi-cloud-upload' },
    ],
    mostrar_menu: false
  }),
  mounted() {
    //sessionStorage.setItem('url', 'http://192.168.0.128:4000/');
    sessionStorage.setItem('url', 'https://makode-tonaescola.herokuapp.com/');
  },
  methods: {
    ev_menu() {
      this.mostrar_menu = !this.mostrar_menu
    },
    clickItemMenu(id) {
      // Aluno
      if (id == 0) {
        this.$router.push({ name: "Painel" });
      } else if (id == 3) {
        this.$router.push({ name: "Aluno" });
      }

      //this.ev_menu();
    }
  }
};
</script>

<style scope>
.m_perfil {
  max-width: 50;
}

.c_app {
  background-color: grey;
}

.c_toolbar {
  background-color: rgb(238, 238, 238);
}

.c_conta_usuario {
  margin-right: 20px;
}

.menuDrawer {
  max-width: 280px;
  background-color: grey;
}

.mainView {
  padding-top: 15px;
  padding-right: 25px;
  padding-bottom: 15px;
  padding-left: 25px;

  background-color: grey;
}

.mainView_menu {
  padding-top: 15px;
  padding-right: 25px;
  padding-bottom: 15px;
  padding-left: 15px;
  background-color: grey;
}
</style>
